import { useCallback, useState } from 'react';

import { InAppPopulatedSaleResult, InAppSaleSearch, listInAppSales } from 'lib/models/order';

function useInAppSales() {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<InAppPopulatedSaleResult>({
		total: 0,
		elements: [],
	} as InAppPopulatedSaleResult);

	const refetch = useCallback(async (data: InAppSaleSearch) => {
		setLoading(true);
		const response = await listInAppSales(data);
		setData(response);
		setLoading(false);
	}, []);

	return { loading, data, refetch, setLoading };
}

export default useInAppSales;
